import { registerFastchannelHost, type FastchannelHost } from './host';
import { servicesRoutes } from './route';
import { serviceScopes } from './service';

/**
 * The module for the app to mount: its services-hub routes and catalog scopes (plain data; the
 * console stays a lazy chunk behind `route.ts`). Taking the host is the only way to get them, so
 * the app cannot mount the module and forget what it reads at render time.
 */
export function createFastchannelModule(host: FastchannelHost) {
  registerFastchannelHost(host);
  return { servicesRoutes, serviceScopes };
}

export type { FastchannelHost } from './host';
